import api from './api';

export interface PermissoesVinculado {
  id: string;
  nome: string;
}


export interface TipoModuloPerfilPermissao {
  id: string;
  nome: string;
  codigo: number,
  permissoes: PermissoesVinculado[]
}

export interface ModuloPerfilPermissao {
  id: string;
  descricao: string;
  nome: string;
  tipo: TipoModuloPerfilPermissao[]
}


export interface Permissoes {
  index: number;
  itemEditado: boolean;
  id: string;
  codigo: string,
  nome: string
}


export interface CreatPerfil {
  nome: string,
  descricao: string,
}


export interface CreatModuloPerfil {
  id: string;
  descricao: string;
  nome: string;
}

export interface TipoModuloModuloPerfilAcessoPermissaoResult {
  tipoModuloModuloPerfilAcessoId: string;
  permissaoId: string;
}

export const getAllModuloPerfilPermissao = () => api.get<ModuloPerfilPermissao[]>('moduloPerfilPermissao');
export const getAllPermissoes = () => api.get<Permissoes[]>('moduloPerfilPermissao/getAllPermissoes');
export const updatePermissoe = (values: Permissoes) => api.put<Permissoes>(`moduloPerfilPermissao/updatePermissoe/${values.id}`, values);

export const postPerfil = (values: CreatPerfil) => api.post<boolean>('moduloPerfilPermissao/creatPerfil', values);
export const putPerfil = (values: CreatModuloPerfil) => api.put<boolean>(`moduloPerfilPermissao/updatePerfil/${values.id}`, values);

export const creatModuloPerfilPermissao = (values: CreatModuloPerfil) => api.post<CreatModuloPerfil>('moduloPerfilPermissao/creatModuloPerfilPermissao', values);
export const getAllPermissoesModuloId = (moduloId: string) => api.get<Permissoes[]>(`moduloPerfilPermissao/getAllPermissoesModuloId/${moduloId}`)

export const postAssociarPermissaoComModuloPerfilPermissao = (listTipoModuloModuloPerfilAcessoPermissaoResult: TipoModuloModuloPerfilAcessoPermissaoResult[]) => {
  const itemPost = { itens: listTipoModuloModuloPerfilAcessoPermissaoResult };
  return api.post<TipoModuloModuloPerfilAcessoPermissaoResult>(`moduloPerfilPermissao/postAssociarPermissaoComModuloPerfilPermissao`, itemPost)
}


export const updateModuloPerfilPermissao = (values: CreatModuloPerfil) => api.put(`moduloPerfilPermissao/updateModuloPerfilPermissao/${values.id}`, values);

export const deleteModuloPerfilPermissao = (id: string) => api.delete(`moduloPerfilPermissao/deleteModuloPerfilPermissao/${id}`);
export const deletTipoModuloModuloPerfilAcessoPermissao = (id: string) => api.delete(`moduloPerfilPermissao/deletTipoModuloModuloPerfilAcessoPermissao/${id}`);

export const getAllPermissoesByModuloId = (moduloId: string) => api.get<Permissoes[]>(`moduloPerfilPermissao/getAllPermissoesByModuloId/${moduloId}`);